let data = {
  geoCoordMap: {
    北京东站货场铁路职工住房项目C地块项目: [
      116.48427,
      39.90086,
      "北京市",
      "京北分公司",
    ],
    顺义区天竺综保区围网建设E片区棚户区改造项目: [
      116.546158,
      40.114849,
      "北京市",
      "京北分公司",
    ],
    顺义区樱花园A片区一期项目: [116.70602, 40.0619, "北京市", "京北分公司"],
    顺义区樱花园小区房屋产权置换A片区项目二期工程项目: [
      116.70602,
      40.0619,
      "北京市",
      "京北分公司",
    ],
    海淀北部地区知能交通应急指挥中心工程项目: [
      116.22818,
      40.08084,
      "北京市",
      "京北分公司",
    ],

    中国人民大学通州新校区西区学部楼二期项目: [
      116.811874,
      39.854691,
      "北京市",
      "京南分公司",
    ],
    中国人民大学通州新校区南区学部一期工程项目: [
      116.728943,
      39.916401,
      "北京市",
      "京南分公司",
    ],
    "西红门镇DX04-0102-6013地块R2二类居住用地项目": [
      116.350441,
      39.790527,
      "北京市",
      "京南分公司",
    ],
    通州区东小马6016地块住宅项目: [116.67939, 39.86513, "北京市", "京南分公司"],

    雄安新区大学园图书馆项目: [115.97847, 39.028862, "河北省", "雄安分公司"],
    "雄东片区B单元安置房项目、公共服务设施项目、市政公用工程项目": [
      116.154633,
      38.996281,
      "河北省",
      "雄安分公司",
    ],
    眉山加州智慧城三期住宅工程项目: [
      104.317734,
      30.606691,
      "四川省",
      "四川分公司",
    ],

    郫都区东方氢能产业园项目: [103.90256, 30.79589, "四川省", "四川分公司"],
    渝昆高铁川渝段站房一标项目: [105.930153, 29.29817, "重庆市", "四川分公司"],
    五津街道28亩住宅地块开发项目: [
      103.813461,
      30.416466,
      "四川省",
      "四川分公司",
    ],
    四川国际航展房屋建设及配套项目: [
      104.339134,
      30.926893,
      "四川省",
      "四川分公司",
    ],
    "昭阳区母鹿荷花棚户区改造安置（1号、2号地块）建设项目": [
      103.689774,
      27.312012,
      "云南省",
      "四川分公司",
    ],
    长沙机场改扩建工程综合交通枢纽工程项目: [
      113.2398,
      28.16892,
      "湖南省",
      "湖南分公司",
    ],
    "新建沪渝蓉高铁武汉至宜昌段宜昌北站站房及相关工程WYZF-3标项目": [
      111.476494,
      30.718374,
      "湖南省",
      "湖南分公司",
    ],
    国网湖北黄石供电公司生产综合用房项目: [
      115.06611,
      30.22286,
      "湖南省",
      "湖南分公司",
    ],
    芙蓉生态新城六号安置小区西地块工程项目: [
      113.069216,
      28.197178,
      "湖南省",
      "湖南分公司",
    ],
    郑州轨道交通项目: [113.5898, 34.86708, "河南省", "直属项目"],
    城市副中心图书馆项目: [116.65714, 39.90998, "北京市", "直属项目"],
    城市副中心站综合交通枢纽项目: [116.707779, 39.883595, "北京市", "直属项目"],
    社会事业管理中心: [116.27919, 39.834949, "北京市", "直属项目"],
    铁兴公司: [116.517479, 39.927372, "北京市", "直属项目"],
    离退休: [116.299576, 39.84412, "北京市", "直属项目"],
    容东片区二分部: [115.889091, 39.034683, "河北省", "直属项目"],
    "廊坊临空经济区29个村街回迁安置房（永清片区）项目第三分部": [
      116.5204,
      39.40349,
      "河北省",
      "直属项目",
    ],
    兰州中川国际机场综合交通枢纽工程项目: [
      103.6587,
      103.6587,
      "甘肃省",
      "直属项目",
    ],
    "长春博览城项目首开期D01-1、E01-1地块工程项目": [
      125.3075,
      43.73798,
      "吉林省",
      "直属项目",
    ],
    青岛中法国际客厅暨中法工业创新中心工程项目: [
      120.0909,
      36.13305,
      "山东省",
      "直属项目",
    ],
    章丘区白云路以西区域棚改旧改安置房建设A区项目: [
      117.5606,
      36.70477,
      "山东省",
      "直属项目",
    ],
    新建常德经益阳至长沙铁路长沙西站站房及相关工程项目二分部: [
      112.8311,
      28.26235,
      "湖南省",
      "直属项目",
    ],
    新建渝黔铁路重庆东站站房及配套综合交通枢纽工程项目: [
      106.6691,
      29.50458,
      "重庆市",
      "直属项目",
    ],
    "哈尔滨二四二医院新建儿产、外科综合楼项目": [
      126.669,
      45.5809,
      "黑龙江省",
      "直属项目",
    ],
    "B208中铁建工-2022-16号项目": [116.2195, 40.07439, "北京市", "直属项目"],
    "金隅（常州）钟楼项目": [119.9014, 31.80164, "江苏省", "直属项目"],
    "B601-中铁建工-2022-06项目": [116.2947, 39.92382, "北京市", "直属项目"],
    中兵未来科研中心建设工程项目: [116.4761, 40.11994, "北京市", "直属项目"],
    北京轨道交通13号线扩能提升工程土建施工23合同段项目: [
      116.3388,
      39.99316,
      "北京市",
      "直属项目",
    ],
    北京园博数字经济产业园创新中心项目: [
      116.1947,
      39.84972,
      "北京市",
      "直属项目",
    ],
    装饰公司: [113.0048, 28.18544, "湖南省", "直属项目"],
    安装公司: [116.2714, 39.72248, "北京市", "直属项目"],
    物资公司: [116.5176, 39.93785, "北京市", "直属项目"],
    "沈白高铁辽宁段ZF-1标项目": [123.9084, 41.8972, "辽宁省", "直属项目"],
    新建哈尔滨至铁力铁路房建工程项目: [
      126.9768,
      46.6112,
      "黑龙江省",
      "直属项目",
    ],
    遂溪江洪乐民100MW风电项目: [109.7049, 21.12741, "广东省", "直属项目"],
    "西城区大栅栏（H地块）工程项目": [
      116.39785,
      39.89214,
      "北京市",
      "直属项目",
    ],
    雄忻高铁雄安地下段及相关工程3标项目: [
      115.819572,
      38.86718,
      "河北省",
      "直属项目",
    ],
    郭桑园棚户区改造工程项目: [116.704361, 39.55817, "河北省", "直属项目"],
    "天赐材料(江门)有限公司项目": [113.03231, 22.45877, "广东省", "直属项目"],
    "B208中铁建工-2023-60号项目": [121.52609, 31.25956, "上海市", "直属项目"],
    王寨小区棚户区改造工程项目: [116.735504, 39.520748, "河北省", "直属项目"],
  },
  datas: [],
};
let formate = function () {
  for (let i in data.geoCoordMap) {
    data.datas.push({
      name: i,
      value: [...data.geoCoordMap[i], i],
      belong: data.geoCoordMap[i][3],
    });
  }
};
formate();
export default data;
